import { GetProps, Tooltip } from 'antd'

import { AnnouncementEntity } from '@eastcoal/api/trade/interface'

import { pick } from '@eastcoal/common/utils/object'

import { useCrudFormStore } from '@eastcoal/formily/components/CrudForm/Store/hooks/useStore'
import { RadioGroup } from '@eastcoal/formily/components/Radio'

import { AnnouncementPublishTimeUpdateStrategy } from '../../../../enums/AnnouncementPublishTimeUpdateStrategy'

export const PublishTimeUpdateStrategyRadioGroup = (
  props: GetProps<typeof RadioGroup>
) => {
  const { detailData: _deatilData } = useCrudFormStore(state =>
    pick(state, ['detailData'])
  )
  const detailData = _deatilData as AnnouncementEntity
  const firstPublishTime = detailData.firstPublishTime
  const options = [
    {
      label: (
        <Tooltip title={firstPublishTime}>
          <span>首次发布时间</span>
        </Tooltip>
      ),
      value: AnnouncementPublishTimeUpdateStrategy.FIRST_PUBLISHED
    },
    {
      label: '最新发布时间',
      value: AnnouncementPublishTimeUpdateStrategy.LATEST_PUBLISHED
    }
  ]

  return <RadioGroup {...props} options={options} />
}
